export const state = {
    steps: [],
}

export const mutations = {
    ADD_STEP(state, step) {
        state.steps.push(step)
    },
    REMOVE_STEP(state) {
        state.steps.pop()
    }
}
